export default __webpack_public_path__ + "static/abstractbg-5ee099ebaec93e4b51ebee58c51fca16.jpg";